import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import {
  Bid,
  Datastore,
  DatastoreDocument,
  ProjectViewProject,
  ProjectViewUser,
} from '@freelancer/datastore';
import { ModalRef } from '@freelancer/ui';
import { ProjectTypeApi } from 'api-typings/projects/projects';
import * as Rx from 'rxjs';
import { map } from 'rxjs/operators';

interface Payload {
  bid: Bid;
  user: ProjectViewUser;
  project: ProjectViewProject;
}

@Component({
  template: `
    <fl-bit class="Container">
      <ng-container *ngIf="(payload$ | async) as payload; else: Loading">
        <app-hourly-hourly-award-modal
          *ngIf="payingHourly"
          [bid]="payload.bid"
          [project]="payload.project"
          (switchAwardType)="switchAwardType($event)"
          (close)="close($event)"
        ></app-hourly-hourly-award-modal>
        <app-hourly-fixed-award-modal
          *ngIf="!payingHourly"
          [bid]="payload.bid"
          [user]="payload.user"
          [project]="payload.project"
          (switchAwardType)="switchAwardType($event)"
          (close)="close($event)"
        ></app-hourly-fixed-award-modal>
      </ng-container>
      <ng-template #Loading>
        <fl-spinner [overlay]="true"></fl-spinner>
      </ng-template>
    </fl-bit>
  `,
  styleUrls: ['./hourly-award-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HourlyAwardModalComponent implements OnInit {
  @Input() bidId: number;

  payingHourly: boolean;

  bidDoc: DatastoreDocument<'bids'>;
  userDoc: DatastoreDocument<'projectViewUsers'>;
  projectDoc: DatastoreDocument<'projectViewProjects'>;
  payload$: Rx.Observable<Payload>;

  constructor(
    private datastore: Datastore,
    private modalRef: ModalRef<HourlyAwardModalComponent>,
  ) {}

  ngOnInit() {
    this.payingHourly = true;

    this.bidDoc = this.datastore.document('bids', this.bidId);

    this.userDoc = this.datastore.document(
      'projectViewUsers',
      this.bidDoc.valueChanges().pipe(map(b => b.bidderId)),
    );

    this.projectDoc = this.datastore.document(
      'projectViewProjects',
      this.bidDoc.valueChanges().pipe(map(b => b.projectId)),
    );

    this.payload$ = Rx.combineLatest(
      this.bidDoc.valueChanges(),
      this.userDoc.valueChanges(),
      this.projectDoc.valueChanges(),
    ).pipe(
      map(([bid, user, project]) => ({
        bid,
        user,
        project,
      })),
    );
  }

  close(event: boolean) {
    this.modalRef.close(event);
  }

  switchAwardType(awardType: string) {
    this.payingHourly = awardType === ProjectTypeApi.HOURLY;
  }
}
